import { CONTACT_EMAIL, INSTAGRAM_URL, COMPANY } from '../site';

function EmailIcon() {
  return (
    <svg
      className="App-footer-icon-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67z" />
      <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg
      className="App-footer-icon-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" />
    </svg>
  );
}

function CompanyFooter() {
  return (
    <footer className="App-footer">
      <div className="App-footer-social">
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="App-footer-icon-link"
          aria-label={`Email ${CONTACT_EMAIL}`}
        >
          <EmailIcon />
        </a>
        <a
          href={INSTAGRAM_URL}
          className="App-footer-icon-link"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram — DJM Roofing and Build"
        >
          <InstagramIcon />
        </a>
      </div>
      <p className="App-footer-company">
        {COMPANY.name}
        <br />
        Registered in England and Wales · Company number{' '}
        <a
          href={COMPANY.companiesHouseUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {COMPANY.number}
        </a>
      </p>
    </footer>
  );
}

export default CompanyFooter;
